export default __webpack_public_path__ + "static/media/Polymer_Logistics_6408.ee9af1e0.png";